import { combineReducers } from "redux";
import authReducer from "../features/Auth/slices/authReducer";
import shopReducer from "../features/Shop/slices/shopReducer";
import zaloStatusReducer from "../features/Shop/slices/zaloStatusReducer";
import autoAssignReducer from "../features/Setting/autoAssignSlice";
import chatbotEventAccessReducer from "../features/Chatbot/chatbotEventAccessSlice";

const rootReducer = combineReducers({
  auth: authReducer,
  shops: shopReducer,
  zaloStatus: zaloStatusReducer,
  autoAssign: autoAssignReducer,
  chatbotEventAccess: chatbotEventAccessReducer,
});

export default rootReducer;
